(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bm"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.buyInit) return;
    root.dataset.buyInit = 'true';
    const subOpen = root.querySelector('[data-buy-sub-open]');
    const subModal = root.querySelector('[data-buy-sub-modal]');
    if (subOpen && subModal && typeof subModal.showModal === 'function' && !subModal.dataset.subWired) {
      subModal.dataset.subWired = 'true';
      subOpen.addEventListener('click', () => subModal.showModal());
      const closeBtn = subModal.querySelector('[data-buy-sub-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => subModal.close());
      // Explicit Esc: the UA cancel path does this natively, but stating
      // it here makes the behaviour ours to guarantee (and to verify).
      subModal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); subModal.close(); }
      });
    }
    const variants = JSON.parse(root.querySelector('[data-buy-variants]').textContent);
    const selects = [...root.querySelectorAll('[data-buy-option]')];
    const priceEl = root.querySelector('[data-buy-price]');
    const percupEl = root.querySelector('[data-buy-percup]');
    const idInput = root.querySelector('[data-buy-variant-id]');
    const atc = root.querySelector('[data-buy-atc]');

    const money = (cents) => {
      const rupees = cents / 100;
      const formatted = rupees % 1 === 0 ? rupees.toLocaleString('en-IN') : rupees.toLocaleString('en-IN', { minimumFractionDigits: 2 });
      return '₹' + formatted;
    };

    const resolve = () => {
      const chosen = selects.map(s => s.value);
      const match = variants.find(v => chosen.every((val, i) => v['option' + (i + 1)] === val));
      if (!match) return;
      idInput.value = match.id;
      priceEl.textContent = money(match.price);
      if (percupEl) {
        // Liquid's variants JSON exposes grams as `weight` (the storefront
        // .js endpoint's `grams` key does not exist here).
        const cupsPerPack = Number(percupEl.dataset.cupsPerPack) || 0;
        if (cupsPerPack > 0) {
          const packPerCup = Math.round(match.price / cupsPerPack / 100) * 100;
          percupEl.textContent = cupsPerPack + ' brew bags · ' + money(packPerCup) + ' a cup';
          percupEl.hidden = false;
        } else if (match.weight > 0) {
          // Per-cup at the 16g standard (§5.5); cups floored to the §0
          // figures; price kept in paise for money().
          const cups = Math.floor(match.weight / 16);
          const perCup = Math.round(match.price * 16 / match.weight / 100) * 100;
          const weightLabel = match.weight >= 1000 ? (match.weight / 1000) + ' kg' : match.weight + ' g';
          percupEl.textContent = weightLabel + ' · about ' + cups + ' cups · ' + money(perCup) + ' a cup';
          percupEl.hidden = false;
        } else {
          percupEl.hidden = true;
        }
      }
      const span = atc.querySelector('span');
      if (match.available) {
        atc.removeAttribute('disabled');
        span.textContent = atc.dataset.label || 'Add to cart';
      } else {
        atc.setAttribute('disabled', '');
        span.textContent = 'Sold out';
      }
    };
    // Out-of-stock handling: the last option select depends on the ones
    // before it. Unavailable combinations get disabled plus a " — Sold out"
    // suffix (native <select> options cannot render strikethrough reliably);
    // choosing a size auto-selects the first available grind rather than
    // presenting a misleading sold-out state. The genuine out-of-stock
    // state appears only when every grind is unavailable for that size.
    const depSel = selects.length > 1 ? selects[selects.length - 1] : null;
    if (depSel) [...depSel.options].forEach(o => { o.dataset.base = o.textContent; });
    const updateAvailability = () => {
      if (!depSel) return;
      const chosen = selects.slice(0, -1).map(s => s.value);
      let anyAvailable = false;
      [...depSel.options].forEach(o => {
        const v = variants.find(v => chosen.every((val, i) => v['option' + (i + 1)] === val) && v['option' + selects.length] === o.value);
        const ok = !!(v && v.available);
        o.disabled = !ok;
        o.textContent = o.dataset.base + (ok ? '' : ' — Sold out');
        if (ok) anyAvailable = true;
      });
      if (depSel.selectedOptions[0] && depSel.selectedOptions[0].disabled && anyAvailable) {
        depSel.value = [...depSel.options].find(o => !o.disabled).value;
      }
    };
    selects.forEach((s, i) => s.addEventListener('change', () => {
      if (i < selects.length - 1) updateAvailability();
      resolve();
    }));
    updateAvailability();
    resolve();

    const qtyValue = root.querySelector('[data-buy-qty-value]');
    const qtyInput = root.querySelector('[data-buy-qty-input]');
    root.querySelectorAll('[data-buy-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const next = Math.max(1, parseInt(qtyValue.textContent, 10) + parseInt(btn.dataset.buyQty, 10));
        qtyValue.textContent = next;
        qtyInput.value = next;
      });
    });

    root.querySelectorAll('[data-buy-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-buy-thumb]').forEach(t => t.classList.toggle('is-active', t === thumb));
        root.querySelectorAll('[data-buy-media]').forEach(img => {
          img.hidden = img.dataset.buyMedia !== thumb.dataset.buyThumb;
        });
      });
    });

    const pinWrap = root.querySelector('[data-buy-pin-zones]');
    if (pinWrap) {
      let zones = null;
      try { zones = JSON.parse(pinWrap.dataset.buyPinZones); } catch (e) { zones = null; }
      const result = pinWrap.querySelector('[data-buy-pin-result]');
      pinWrap.querySelector('[data-buy-pin-check]').addEventListener('click', () => {
        if (!zones) return;
        const pin = pinWrap.querySelector('[data-buy-pin-input]').value.trim();
        result.hidden = false;
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          result.textContent = 'Please enter a valid 6-digit pin code.';
          return;
        }
        const hit = Object.keys(zones).filter(prefix => pin.startsWith(prefix)).sort((a, b) => b.length - a.length)[0];
        result.textContent = hit ? zones[hit] : (zones['default'] || 'We deliver across India.');
      });
    }
  };
  document.querySelectorAll('.mf-buy').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.mf-buy');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-brew"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.brewInit) return;
    root.dataset.brewInit = 'true';
    const tabs = [...root.querySelectorAll('[data-brew-tab]')];
    if (tabs.length < 2) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-brew-panel]').forEach(panel => {
          panel.hidden = panel.dataset.brewPanel !== tab.dataset.brewTab;
        });
        root.querySelectorAll('[data-brew-media]').forEach(img => {
          const on = img.dataset.brewMedia === tab.dataset.brewTab;
          img.classList.toggle('is-active', on);
          img.classList.toggle('is-hidden', !on);
        });
      });
    });
  };
  document.querySelectorAll('.mf-brew').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.mf-brew');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.heroInit) return;
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;
    root.dataset.heroInit = 'true';
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    let index = 0;

    const show = (n) => {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.toggleAttribute('hidden', i !== index);
      });
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      schedule(); // any slide change – manual or automatic – resets the timer (S28)
    };

    /* (S28) Auto-rotation engine. Runs only when the section setting is
       non-zero (data-hero-autorotate, clamped to >= 4s in Liquid) AND no
       pause condition holds. Every behaviour here is mandatory per the
       decision of record: pause on hover / focus-within / touch, reset on
       manual advance, dead under prefers-reduced-motion, stopped while
       the tab is hidden, inert with one slide (init returns above). */
    const rotateMs = (Number(root.dataset.heroAutorotate) || 0) * 1000;
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let pausedHover = false;
    let pausedFocus = false;
    let pausedTouch = false;
    const canRun = () =>
      rotateMs >= 4000 &&
      !REDUCED.matches &&
      document.visibilityState === 'visible' &&
      !pausedHover && !pausedFocus && !pausedTouch;
    function schedule() {
      clearTimeout(timer);
      timer = null;
      if (canRun()) timer = setTimeout(() => show(index + 1), rotateMs);
    }
    if (rotateMs > 0) {
      root.addEventListener('mouseenter', () => { pausedHover = true; schedule(); });
      root.addEventListener('mouseleave', () => { pausedHover = false; schedule(); });
      root.addEventListener('focusin', () => { pausedFocus = true; schedule(); });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) { pausedFocus = false; schedule(); }
      });
      document.addEventListener('visibilitychange', schedule);
      REDUCED.addEventListener('change', schedule);
      schedule();
    }

    root.querySelector('[data-hero-prev]').addEventListener('click', () => show(index - 1));
    root.querySelector('[data-hero-next]').addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });

    let touchX = null;
    root.addEventListener('touchstart', (event) => {
      touchX = event.changedTouches[0].clientX;
      pausedTouch = true;
      schedule();
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      pausedTouch = false;
      if (touchX === null) { schedule(); return; }
      const dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (dx > 50) show(index - 1);
      else if (dx < -50) show(index + 1);
      else schedule();
    }, { passive: true });
  };

  document.querySelectorAll('[data-hero-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-hero-carousel]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-journey"] && !Shopify.designMode) return;
  try {
    
(() => {
  const arm = (section) => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const track = section.querySelector('[data-journey]');
    if (!track || track.classList.contains('mf-journey--armed')) return;
    track.classList.add('mf-journey--armed');
    const io = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        track.classList.add('mf-journey--in-view');
        io.disconnect();
      }
    }, { threshold: 0.35 });
    io.observe(track);
  };
  document.querySelectorAll('.mf-journey').forEach(arm);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.mf-journey');
    if (section) arm(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
